import { render } from "./MicroscopeZoom.vue?vue&type=template&id=45dfcba9&scoped=true"
import script from "./MicroscopeZoom.vue?vue&type=script&lang=js"
export * from "./MicroscopeZoom.vue?vue&type=script&lang=js"

import "./MicroscopeZoom.vue?vue&type=style&index=0&id=45dfcba9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dfcba9"]])

export default __exports__